require('../modules/esnext.composite-key');
require('../modules/esnext.composite-symbol');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/keys-composition.js
// module id = 849
// module chunks = 2